module.exports = __webpack_public_path__ + "img/sy.64f0d2d7.svg";